<mat-selection-list (selectionChange)="change($event)">
  @for (option of options$ | async; track option) {
    <mat-list-option [value]="option.code" [selected]="(selectedOptions$ | async).indexOf(option.code) !== -1">
      <div matListItemLine>{{ option.caption }}</div>
      <div matListItemLine class="description">{{ option.description }}</div>
    </mat-list-option>
  }
</mat-selection-list>
